import React from 'react';
import styled from 'styled-components';

import { DARK_BLACK, PRIMARY_BLUE } from 'constants/colours';

const InputLabel = styled.label`
  display: block;
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
  color: ${DARK_BLACK};
  opacity: ${({ disabled }) => disabled && '0.5'};
  ${({ showAsterisk }) =>
    showAsterisk &&
    `&::after {
      content: '*';
      color: ${PRIMARY_BLUE};
  }`}
`;

export default InputLabel;
